import { render, staticRenderFns } from "./SendIndicationContacts.vue?vue&type=template&id=20b25297&scoped=true"
import script from "./SendIndicationContacts.vue?vue&type=script&lang=js"
export * from "./SendIndicationContacts.vue?vue&type=script&lang=js"
import style0 from "./SendIndicationContacts.vue?vue&type=style&index=0&id=20b25297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b25297",
  null
  
)

export default component.exports